import React, { createContext, useContext } from 'react';
import GooglePayUtils from './googlePayUtils';

export const GooglePayUtilsContext = createContext();

export const useGooglePayUtilsContext = () => {
  const context = useContext(GooglePayUtilsContext);
  return context || {};
};

export const GooglePayUtilsConsumer = GooglePayUtilsContext.Consumer;
export const GooglePayUtilsProvider = GooglePayUtilsContext.Provider;

const injectGooglePayUtils = WrappedComponent => (props) => {
  const googlePayment = new GooglePayUtils();

  return (
    <GooglePayUtilsProvider value={googlePayment}>
      <WrappedComponent {...props} />
    </GooglePayUtilsProvider>
  );
};

export default injectGooglePayUtils;
